export const SOFA_6_COLUMNS = {
  gridColumns: [
    {
      dataType: 'enum',
      displayName: 'Question',
      propertyName: 'section',
      allowedValues: ['11', '12', '13'],
      queryType: 'String!'
    },
    {
      dataType: 'string',
      displayName: 'Legal Entity',
      propertyName: 'legalEntityId',
    },
    {
      dataType: 'string',
      displayName: 'Total Amount or Value',
      propertyName: 'amount',
    },
    {
      dataType: 'string',
      displayName: 'Name / Who',
      propertyName: 'name',
    },

    {
      dataType: 'string',
      displayName: 'Address 1',
      propertyName: 'address1',
    },
    {
      dataType: 'string',
      displayName: 'Address 2',
      propertyName: 'address2',
    },
    {
      dataType: 'string',
      displayName: 'Address 3',
      propertyName: 'address3',
    },
    {
      dataType: 'string',
      displayName: 'City',
      propertyName: 'city',
    },
    {
      dataType: 'string',
      displayName: 'State',
      propertyName: 'state',
    },
    {
      dataType: 'string',
      displayName: 'Zip',
      propertyName: 'zip',
    },
    {
      dataType: 'string',
      displayName: 'Country',
      propertyName: 'country',
    },
    {
      dataType: 'string',
      displayName: 'Email / Website',
      propertyName: 'email',
    },
    {
      dataType: 'string',
      displayName: 'Trustee / Other',
      propertyName: 'trusteeOther',
    },
    {
      dataType: 'string',
      displayName: 'Description',
      propertyName: 'description',
    },
    {
      dataType: 'string',
      displayName: 'Description',
      propertyName: 'description',
    },
    {
      dataType: 'string',
      displayName: 'Dates Of Payment / Transfer',
      propertyName: 'datesOfPayment',
    },
    {
      dataType: 'string',
      displayName: 'Relationship To Debtor',
      propertyName: 'relationshipToDebtor',
    },

    {
      allowedValues: ['No', 'All', 'Address', 'Name'],
      dataType: 'enum',
      displayName: 'Redact',
      propertyName: 'redact',
      queryType: 'RedactType'
    },
    {
      dataType: 'string',
      displayName: 'Footnote',
      propertyName: 'footnote',
    },
    {
      dataType: 'string',
      displayName: 'Entity Comments',
      propertyName: 'entityComments',
    },
  ],
};
